/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const PlayVideo = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 22 26">
      <path
        d="M22.5,5 L17,5 L17,2.5 C17,1.67157288 16.3284271,1 15.5,1 L2.5,1 C1.67157288,1 1,1.67157288 1,2.5 L1,21.5 C1,22.1630412 1.2633921,22.798926 1.73223305,23.267767 C2.20107399,23.7366079 2.83695878,24 3.5,24 L17,24 C18.1045695,24 19,23.1045695 19,22 L19,19.5 C19,19.2238576 18.7761424,19 18.5,19 L17,19 L17,16 L22.5,16 C23.3284271,16 24,15.3284271 24,14.5 L24,6.5 C24,5.67157288 23.3284271,5 22.5,5 Z M5,19.5 L5,21.5 C5,22.3284271 4.32842712,23 3.5,23 C2.67157288,23 2,22.3284271 2,21.5 L2,2.5 C2,2.22385763 2.22385763,2 2.5,2 L15.5,2 C15.7761424,2 16,2.22385763 16,2.5 L16,5 L10.5,5 C9.67157288,5 9,5.67157288 9,6.5 L9,14.5 C9,15.3284271 9.67157288,16 10.5,16 L16,16 L16,19 L5.5,19 C5.22385763,19 5,19.2238576 5,19.5 Z M18,20 L18,22 C17.9994488,22.5520563 17.5520563,22.9994488 17,23 L5.4888,23 C5.81876191,22.5694167 5.99834525,22.0424703 6,21.5 L6,20 L18,20 Z M23,14.5 C23,14.7761424 22.7761424,15 22.5,15 L10.5,15 C10.2238576,15 10,14.7761424 10,14.5 L10,6.5 C10,6.22385763 10.2238576,6 10.5,6 L22.5,6 C22.7761424,6 23,6.22385763 23,6.5 L23,14.5 Z M15,8 L19,10 L15,13 L15,8 Z"
        id="path-1" />
    </BaseSvgIcon>
  )
}

export default PlayVideo
